import {PAY_AUTH_DOMAIN} from '~/constants/authorize';

export interface BuildPrequalAuthorizeUrlParams {
  analyticsTraceId: string;
  hostname: string;
  origin: string;
  uxMode?: string;
}

const RESULT_PATH = '/pay/installments/prequalifications/authorize';

export const buildPrequalAuthorizeUrl = ({
  analyticsTraceId,
  hostname,
  origin,
  uxMode,
}: BuildPrequalAuthorizeUrlParams) => {
  const payDomain = PAY_AUTH_DOMAIN.replace('https://', '');

  /* eslint-disable @typescript-eslint/naming-convention */
  const params = new URLSearchParams({
    shopify_domain: hostname,
    pay_domain: payDomain,
    analytics_trace_id: analyticsTraceId,
    redirect_source: origin,
    ...(uxMode && {ux_mode: uxMode}),
  });
  /* eslint-enable @typescript-eslint/naming-convention */

  return `${PAY_AUTH_DOMAIN}${RESULT_PATH}?${params}`;
};
